/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum HousingIntakeScenarioTeamRole {
    OWNER = 'Owner',
    MEMBER = 'Member',
    FLAGGED = 'Flagged',
}
